import type { PatientReference } from '@app/icare/entities/patient/schema/Patient'
import { PatientId } from '@app/icare/entities/patient/schema/Patient'
import { AppEntitySchema, entityId } from '@pkg/db/schema'
import { z } from 'zod'

import { PatientFormTypeEnum } from './PatientFormType'

export const PatientFormId = entityId('patientForm')

export type PatientFormIdType = typeof PatientFormId.Type

export const PatientFormCommonSchema = AppEntitySchema.extend({
  id: PatientFormId.schema,
  patientId: PatientId.ref,
  status: z.string().nullish(),
  form: z.any().nullish(),
  type: z.enum(PatientFormTypeEnum.$.zodEnum()),
})

export type PatientFormCommon = Omit<z.infer<typeof PatientFormCommonSchema>, 'patient'> & {
  patient?: PatientReference
}
